var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGravitateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.001,
    height: 14,
    fill: "none",
    viewBox: "0 0 10.001 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.587 0.48309c0.71655-0.32647 1.525-0.48309 2.413-0.48309 0.88698 0 1.6903 0.15626 2.3962 0.48392 0.7065 0.32223 1.2714 0.76876 1.6756 1.3435 0.4228 0.57141 0.6293 1.2278 0.6293 1.9517 0 2.6153-2.7402 3.3653-4.7001 4.2177l-0.57704 0.22239c-0.45517 0.16725-0.80576 0.41144-1.068 0.72982-0.2473 0.30379-0.36148 0.61959-0.36148 0.95939 0 0.4565 0.16975 0.8014 0.50999 1.0759 0.36151 0.2819 0.84516 0.4407 1.4954 0.4407 5 0.075 1.4577 3.7781-2.5636 2.1169l-0.00725-3e-3c-0.74701-0.3214-1.3468-0.7742-1.779-1.3633l-0.00303-0.0042c-0.43434-0.6055-0.64716-1.2957-0.64716-2.0547 0-0.8239 0.27436-1.5779 0.81222-2.2489 0.35293-0.44026 0.78638-0.81614 1.2952-1.1293l2.8915-1.1972 0.26165-0.09119c0.45139-0.17071 0.80027-0.40421 1.0624-0.69468 0.25125-0.27844 0.36494-0.57017 0.36494-0.88956 0-0.38635-0.14399-0.67264-0.43414-0.90146l-0.01268-0.01033c-0.28311-0.23847-0.67868-0.37919-1.241-0.37919-0.56173 0-0.96747 0.14055-1.2656 0.38407-0.29919 0.24438-0.44092 0.53541-0.44092 0.90691l-2.9946-0.08682c0-0.72257 0.19947-1.3784 0.60982-1.9505l0.00153-0.00214c0.41475-0.57159 0.97718-1.0183 1.6731-1.3417z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.2934 3.8661c0 0.32327 0.1105 0.61628 0.34949 0.89313 0.26206 0.28917 0.60297 0.51448 1.0364 0.67232l-2.7163 1.2123c-1.073-0.72866-1.6642-1.6818-1.6642-2.8646z",
    fill: "url(#paint0_linear_1920_20930)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.1904 7.8874c0.5353 0.66883 0.8102 1.416 0.8102 2.229l-2.9945-0.2083c0-0.3446-0.12156-0.6612-0.38768-0.96353l-0.01053-0.01238c-0.26227-0.31877-0.61305-0.5633-1.0686-0.7307l-0.00616-0.00227-0.33781-0.12883 2.8261-1.2458c0.4594 0.30197 0.8507 0.65562 1.169 1.0627z",
    fill: "url(#paint1_linear_1920_20930)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.81062 7.8874c-0.53538 0.66883-0.81027 1.416-0.81027 2.229l2.9946-0.2083c0-0.3446 0.12151-0.6612 0.38763-0.96353l0.01054-0.01238c0.26227-0.31877 0.61305-0.5633 1.0686-0.7307l0.00616-0.00227 0.33781-0.12883-2.8261-1.2458c-0.45942 0.30197-0.85069 0.65562-1.1689 1.0627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 10.117c0 0.7686-0.2118 1.4613-0.6502 2.0588-0.4322 0.5892-1.032 1.0419-1.779 1.3633l-0.0072 0.0031c-0.75131 0.3104-1.6101 0.4581-2.5636 0.4581v-2.575c0.6524 0 1.1272-0.1597 1.4742-0.4387l0.00515-0.0041c0.35319-0.2764 0.52606-0.6208 0.52606-1.0739z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 10.117c0 0.7686 0.21184 1.4613 0.65019 2.0588 0.43219 0.5892 1.032 1.0419 1.779 1.3633l0.0072 0.0031c0.75134 0.3104 1.6101 0.4581 2.5636 0.4581v-2.575c-0.6524 0-1.1272-0.1597-1.4742-0.4387l-0.00515-0.0041c-0.35319-0.2764-0.5261-0.6208-0.5261-1.0739z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1920_20930",
    x1: 5.5,
    x2: 5.9349,
    y1: 5.5,
    y2: 7.0187,
    gradientTransform: "translate(-3,-1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1920_20930",
    x1: 11,
    x2: 10,
    y1: 10,
    y2: 8.5,
    gradientTransform: "translate(-3,-1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGravitateWhite);
export default __webpack_public_path__ + "static/media/logo-gravitate-white.ba748525d3174111cf3d7e5da90eab61.svg";
export { ForwardRef as ReactComponent };